<script setup lang="ts">
import { isTokenExpired } from "@/utils/globalMethods"
import { useMainStore } from "@/store"
import { useRouter, useRoute } from 'vue-router';
const router = useRouter();
const route = useRoute();
const mainStore = useMainStore()
const expired = isTokenExpired(mainStore.token);

if (expired) {
  // console.log("token已过期");
  mainStore.removeStore()
  router.replace('/')
} else {
  // console.log("token 正常");
  router.replace(location.pathname == '/' ? '/home' : location.pathname+location.search)
}

onMounted(() => {
  // 预下载所有带 preload: true 的异步组件
  router.getRoutes()
    .filter(r => r.meta.preload)
    .forEach(r => r.component?.())
})
</script>

<template>
  <router-view />
</template>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  line-height: 1.5;
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Open Sans, Helvetica Neue, sans-serif;
  -webkit-font-smoothing: antialiased;
}

.maxWidthPx {
  max-width: 430px;
  margin: 0 auto;
}

.maxWidthPxRg0 {
  max-width: 430px;
  right: 0;
  margin: auto;
}

.bg-color {
  background: #f5f8fa;
}
:deep(.showFailToastClass){
    width: auto;
    max-width: 70vw;
}

</style>
